export const environment = {
  production: true,
  TOASTER_POSITION: 'toast-top-right',
  TOASTER_TIMEOUT: 3000
};
